import {flow, types} from "mobx-state-tree";
import {Brand} from "../elements/brand/BrandStore";
import {BrandSelectState} from "../elements/brand/BrandSelectState";
import Manager from "../../manager/Manager";


export const Product = types.model('Product', {
    label: types.optional(types.string, ""),
    url: types.optional(types.string, ""),
})

export const ListViewState = types.model('ListViewState', {
    items: types.optional(types.array(Product), []),
    isLoading: types.optional(types.boolean, false),
    searchInput: types.optional(types.string, ""),
    brandSelected: types.maybe(types.safeReference(Brand)),
    brandSelectState: types.maybeNull(BrandSelectState),
    brandImage: types.optional(types.string, ""),
    page: types.optional(types.number, 1),
    perPage: types.optional(types.integer, 10),
    totalRows: types.optional(types.number, 0),
}).actions((self) => ({

    setBrandImage(image) {
        if (image) {
            self.brandImage = image.data[0]?.attributes?.headerLogo?.data?.attributes?.url
        }
    },
    setBrandSelected(brand) {
        self.brandSelected = brand
    },
    handleSearchChange(event) {
        self.searchInput = event.target.value;
    },
    fetchProducts: flow(function* f() {
        self.isLoading = true
            const brand = self.brandSelectState?.selected?.uuid === "all" ? "" : {"brands": {"name":self.brandSelectState?.selected?.label
                }}
            const searchInput  = self.searchInput === "" ? "" : {"$or":[{"name": {"$containsi": self.searchInput}},{"pageUrl": {"$containsi": self.searchInput}}]}
        const queryParams = {
                ...searchInput,
            ...brand
        }

        self.items = []
        const manager = new Manager()
        const response = yield manager.fetchAllProducts(queryParams, self.page,self.perPage)
        if (response) {
            self.setListItems(response)
        }
        self.isLoading = false
        return response

    }),
    handleSubmit: flow(function* f(event) {
        yield self.fetchProducts()
        yield self.fetchBrandImage()
    }),
    fetchBrandImage: flow(function* f() {
        const manager = new Manager()
        const imageResponse = yield manager.fetchBrandImage(self.brandSelected?.label) || ""
        self.setBrandImage(imageResponse)
    }),
    setListItems(response) {
        self.totalRows = response.meta.pagination.total
        self.items = response.data?.map((item) => {
            return Product.create({
                label: item?.attributes?.name,
                url: item?.attributes?.pageUrl
            })
        })
    },

    //pagination
    updatePage: function (page) {
        self.page = page
    },
    updatePerPage: function (perPage) {
        self.perPage = perPage
    },
     handlePerRowsChange: flow(function* f(newPerPage, page) {
         self.updatePerPage(newPerPage)
         self.updatePage(page)
        yield self.fetchProducts()
    }),

    handlePageUpdate(pageNumber){
        self.page = pageNumber
        self.fetchProducts()
        }
}))
